import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { fetchItems, saveItem,deleteItem,updateItem, saveBulkImportCatalog } from '../../store/actions/items';
import { fetchAllItemTypes } from '../../store/actions/formOptions';
import { selectItems } from '../../store/selectors/items';
import { selectFormOptions } from '../../store/selectors/formOptions';
import Heading from '../../components/Heading';
import ItemsTable from '../../components/ItemsTable';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch,clearSearch } from '../../store/actions/search';
import { selectSearch } from '../../store/selectors/search';
import Loader from '../../components/Loader';
import { selectLoader } from '../../store/selectors/loader';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import { clearValidation } from '../../store/actions/validation';
import { onClearResponseDone } from '../../store/actions/suites';
import { stopLoaders } from '../../store/actions/loader';
import { clearActiveTab, clearActiveSuiteTab, clearActiveCatalogTab,clearActiveContactTab } from "../../store/actions/activeTab";

class Catalog extends Component {
  constructor(props){
    super(props);
    this.state={
    }
  }
  componentDidMount() {
    const { onFetchItems,onFetchAllItemTypes,clearSearch, stopLoaders } = this.props;
    stopLoaders();
    onFetchItems();
    onFetchAllItemTypes()
    clearSearch()
    this.clearSuitesImportResponse();
  }
  componentWillMount(){
    const {clearActiveTab,clearActiveSuiteTab, clearActiveCatalogTab, clearActiveContactTab}=this.props;
    clearActiveTab();
    clearActiveSuiteTab();
    clearActiveCatalogTab();
    clearActiveContactTab();
  }
   /*
    Created By: Sai Prasad
    Created Date: 02/09/2022
    Jira Ticket: JUN-3153
    Description: To clear response and validation.
  */
  clearSuitesImportResponse = () => {
    const { onClearValidation, onClearResponse } = this.props;
    onClearValidation();
    onClearResponse();
}
  onSaveItem= item => {
    let params = {};
    let { onSaveItem,onUpdateItem } = this.props;
    let properties = [];
    if(item.selectedProperties && item.selectedProperties.length > 0) {
      item.selectedProperties.map(sp => {
        properties = [...properties, {id: sp.value}]
      })
    }
    if(item.id){
      params ={
        "id": item.id,
        "name":item.name,
        "MakeName": item.makeName,
        "model": item.model,
        "TypeId": item.typeId,
        "warrantyYears": item.warrantyYears,
        "UserId":this.props.user.id,
        "properties": properties
     }
        onUpdateItem(params)
    }else{
      params ={
        "Name": item.name,
        "MakeName": item.makeName,
        "Model": item.model,
        "TypeId": item.typeId,
        "WarrantyYears": item.warrantyYears ,
        "UserId": this.props.user.id,
        "properties": properties
      }      
     onSaveItem(params)
    }

  }

  onDeleteItem = data =>{
    this.props.onDeleteItem(data.id);
  }

  saveBulkImport = (data) => {
    const { onSaveBulkImportCatalog, user } = this.props;    
    let params = {
      userId: user.id,
      items: data
    }
    onSaveBulkImportCatalog(params);
  }
  render() {
  
    const { items,setSearch, loader } = this.props;
    let brands=[]
    let itemTypes = []
    if(items.length > 0){
      items.map( item => {
        if(brands.length === 0){
          if(item.makeName) {
            brands.push(item.makeName)
          }
        }else{
          if(!brands.includes(item.makeName)){
            if(item.makeName) {
              brands.push(item.makeName)
            }
          }
        }
        return false;
      })
    }
    if(items.length > 0){
      items.map( item => {
        if(itemTypes.length === 0){
          itemTypes.push(item.typeName)
        }else{
          if(!itemTypes.includes(item.typeName)){
            itemTypes.push(item.typeName)
          }
        }
        return false;
      })
    }
    
    return (
     <>
      {
        this.props.prloader ?
          <Loader center={true}/>
          :(null)
      }
      <WithNavigation
        title="Catalog"
        top={(
          <Heading
            headline="Catalog"
            items={[
              {
                key: items.length > 1 ? 'Items' : 'Item',
                value: items.length,
              }, {
                key: brands.length > 1 ? 'Brands' : 'Brand',
                value: brands.length,
              }, {
                key: itemTypes.length > 1 ? 'Types' : 'Type',
                value: itemTypes.length
              }
            ]}
          />
        )}
        bottom={
          // loader ?
          // <Loader />
          // :
          (
          <Tabs
            items={[
              {
                label: 'Items',
                content: (
                  <ItemsTable
                    items={items}
                    onSaveItem={this.onSaveItem}
                    onDeleteItem={this.onDeleteItem}
                    onSearch={e => setSearch({ items: e.target.value.trim() })}
                    onSaveBulkImport={this.saveBulkImport}
                  />
                )
              }
            ]}
          />
        )}
      />
     </>
    );
  }
}

const mapStateToProps = (state,ownProps) => ({
  items: selectItems(state),
  formOptions:selectFormOptions(state),
  user:selectAuthenticatedUser(state),
  search: selectSearch(state),
  loader: selectLoader(state),
  prloader: selectPRLoader(state)

});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchItems: fetchItems,
  onSaveItem: saveItem,
  onFetchAllItemTypes:fetchAllItemTypes,
  onDeleteItem:deleteItem,
  onUpdateItem:updateItem,
  setSearch,
  clearSearch,
  onSaveBulkImportCatalog: saveBulkImportCatalog,
  onClearValidation: clearValidation,
  onClearResponse: onClearResponseDone,
  stopLoaders,
  clearActiveTab:clearActiveTab,
  clearActiveSuiteTab:clearActiveSuiteTab,
  clearActiveCatalogTab:clearActiveCatalogTab,
  clearActiveContactTab:clearActiveContactTab
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Catalog);
